import styled from 'styled-components';
import Heading from '../Heading';
const H6 = styled(Heading).withConfig({
  displayName: "H6",
  componentId: "u4m3dg-0"
})([""]);
H6.propTypes = Heading.propTypes;
H6.defaultProps = Object.assign({}, Heading.defaultProps, {
  tagName: 'h6'
});
H6.displayName = 'H6';
export default H6;